<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings/pos-settings"></ion-back-button>
    </ion-buttons>
    <ion-title>Accepted Payment Types</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccured" (click)="loadPaymentTypes()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccured">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
        <form [formGroup]="paymentTypesForm">
          <ion-item>
            <ion-label>Cash</ion-label>
            <ion-toggle formControlName='cash'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>Debit</ion-label>
            <ion-toggle formControlName='debit'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>Visa</ion-label>
            <ion-toggle formControlName='visa'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>MasterCard</ion-label>
            <ion-toggle formControlName='mastercard'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>AMEX</ion-label>
            <ion-toggle formControlName='amex'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>Cheque</ion-label>
            <ion-toggle formControlName='cheque'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>Giftcard</ion-label>
            <ion-toggle formControlName='giftcard'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>E-Transfer</ion-label>
            <ion-toggle formControlName='etransfer'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>Account</ion-label>
            <ion-toggle formControlName='account'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>Square</ion-label>
            <ion-toggle formControlName='square'></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>Discover</ion-label>
            <ion-toggle formControlName='discover'></ion-toggle>
          </ion-item>
          <br/>
          <ion-button 
            expand="block"
            class="hidden-sm-down" 
            (click)="save()">
            Save
          </ion-button>
        </form>
      </ion-col>
      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>

<ion-footer class="ion-no-margin" class="hidden-md-up" *ngIf="!isLoading && !errorOccured">
  <ion-toolbar class="ion-no-margin ion-no-padding">
    <ion-button 
      class="ion-no-margin"
      expand="block" 
       
      (click)="save()">
      Save
    </ion-button>
  </ion-toolbar>
</ion-footer>